<template>
  <a-row class="content-fix" type="flex">
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1">
      <a-tabs
        :key="$route.fullPath"
        v-model="tabPane"
        class="main-tabs"
        type="card"
        @change="tabPaneChangeHandler"
      >
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>
          <!-- lang tabs -->
          <a-row
            align="middle"
            class="flex-baseline"
            style="margin-bottom: 15px"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="12">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="langTab" class="mb-1x" />
              </a-row>
            </a-col>
          </a-row>

          <!-- title -->
          <a-row
            :class="{ 'form-group--error': emptyTitle }"
            align="middle"
            class="flex-baseline"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Заголовок:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model="form.title[langTab]"
                placeholder="Введите заголовок"
                @input="hotGenerateSlug($event, form, langTab, 'post', 'news')"
              />
              <div v-if="isTitleNull" class="error-text">
                Введите заголовок на одном из языков.
              </div>
            </a-col>
          </a-row>

          <!-- slug -->
          <a-row
            :class="[
              'flex-baseline',
              { 'form-group--error': $v.form.slug.$error }
            ]"
            align="middle"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              ЧПУ:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-row align="middle" type="flex">
                <span class="mr-1 link" @click="copySlug">
                  <a-icon :style="{ fontSize: '22px' }" type="copy" />
                </span>

                <span class="flex-1">
                  <a-col :span="18">
                    <a-input
                      id="slug-input"
                      :value="form.slug"
                      placeholder="Введите человеку понятный урл"
                      @input="onSlugChange"
                    />
                  </a-col>

                  <a-col :span="5">
                    <a-tooltip
                      placement="topLeft"
                      :title="`Генерация ЧПУ на  ${langTab}`"
                    >
                      <a-button
                        :disabled="!form.title[langTab]"
                        class="ml-1"
                        block
                        type="primary"
                        @click="
                          $__slugCompute({
                            event: $event,
                            langTab: langTab,
                            type: 'post',
                            title: form.title,
                            postType: 'news'
                          })
                        "
                      >
                        {{ langTab }}
                        <a-icon type="reload" />
                      </a-button>
                    </a-tooltip>
                  </a-col>
                </span>
              </a-row>
              <div v-if="!form.slug" class="error-text">Введите ЧПУ</div>
              <div
                v-if="errors.slug && current_slug != form.slug"
                class="z-error-text"
              >
                Данный ЧПУ недоступен
              </div>
            </a-col>
          </a-row>

          <!-- position -->
          <a-row align="middle" class="flex-baseline">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Позиция:
            </a-col>
            <a-col :span="12" class="sm-mb">
              <a-input
                v-model.number="form.position"
                placeholder="Введите позицию"
                spellсheck="false"
              />
              <div v-if="!form.position" class="error-text">
                Введите позицию.
              </div>
            </a-col>
          </a-row>

          <!-- status toggle -->
          <a-row style="margin-top: 25px">
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Статус:
            </a-col>
            <a-switch v-model="form.status" />
          </a-row>
        </a-tab-pane>

        <!--photo tab-->
        <a-tab-pane v-if="tabName.includes('photo')" key="photo">
          <span slot="tab"> <a-icon type="picture" />Фото </span>

          <!-- upload photo -->
          <a-row align="middle">
            <a-col
              :span="6"
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Изображения
            </a-col>
            <a-col :span="12">
              <image-upload
                :list="photoList"
                accept="image/jpeg, image/png"
                method-name="gallery"
                multiple
                @change="fileList = arguments[0]"
                @drag-update="updateFilesPosition"
                @set-main-image="main_image = arguments[0]"
              />
            </a-col>
          </a-row>
        </a-tab-pane>

        <!--video tab-->
        <a-tab-pane v-if="tabName.includes('video')" key="video">
          <span slot="tab"> <a-icon type="video-camera" />Видео </span>

          <!-- exclusive video title -->
          <a-row style="margin-bottom: 15px">
            <a-col
              :span="6"
              style="text-align: right; padding-right: 8px; padding-top: 4px"
            >
              Заголовок видео:
            </a-col>
            <a-col :span="12">
              <a-col>
                <a-textarea
                  v-model="video_input.title"
                  placeholder="Введите заголовок"
                  :auto-size="{ minRows: 2 }"
                />
              </a-col>
            </a-col>
          </a-row>

          <a-col>
            <a-row style="margin-bottom: 15px">
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 4px"
              >
                Тип загрузки:
              </a-col>
              <a-col :span="12">
                <a-select
                  v-model="video_input.file_type"
                  placeholder="Выберите тип загрузки видео"
                  show-search
                  style="width: 100%"
                >
                  <a-select-option
                    v-for="item in videoUploadTypes"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.title[$i18n.locale] }}
                  </a-select-option>
                </a-select>
              </a-col>
            </a-row>

            <a-row style="margin-bottom: 15px">
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 4px"
              >
                Ссылка на видео:
              </a-col>
              <a-col :span="12">
                <a-col>
                  <a-textarea
                    v-model="video_input.file"
                    :placeholder="placeholders.video_url[$i18n.locale]"
                    auto-size
                  />
                </a-col>
              </a-col>
            </a-row>

            <a-row style="margin-top: 0" class="mb-2">
              <a-col :span="6" style="text-align: right; padding-right: 8px">
                Эксклюзивное видео:
              </a-col>
              <a-switch v-model="video_input.exclusive" />
            </a-row>

            <!-- <a-row
              v-else
              style="margin-bottom: 15px;"
            >
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px;"
              >
                Файл с компьютера:
              </a-col>
              <a-col :span="12">
                <a-button @click="$refs.videoRef.click()">
                  <input
                    ref="videoRef"
                    accept="video/*"
                    hidden
                    multiple
                    type="file"
                    @change="handleVideoInput"
                  >
                  <a-icon type="upload" />Выберите файл
                </a-button>

                <InputFileItem
                  v-for="(vf, index) in video_file"
                  :key="index"
                  :file="vf"
                  class="mt-2"
                  @delete="video_file.splice(index, 1)"
                />
                <InputFileItem
                  v-for="(vf, index) in filesList"
                  :key="index"
                  :file="{ ...vf, name: vf.file && vf.file.split('/').pop() }"
                  class="mt-2"
                  link
                  @delete="removeVideo(vf)"
                />
              </a-col>
            </a-row> -->

            <a-row
              v-if="video_input.file_type != 1"
              style="margin-bottom: 15px"
            >
              <a-col
                :span="6"
                style="text-align: right; padding-right: 8px; padding-top: 6px"
              >
                Постер (предпросмотр):
              </a-col>
              <a-col :span="12">
                <input
                  ref="videoPosterRef"
                  accept="image/jpeg, image/png"
                  hidden
                  type="file"
                  @change="handleVideoPosterInput"
                />

                <InputFileItem
                  v-if="video_poster_file"
                  :file="video_poster_file"
                  @delete="video_poster_file = null"
                />

                <InputFileItem
                  v-else-if="
                    !poster_deleted && video_input && video_input.thumbnail
                  "
                  class="mt-1 mb-2"
                  :file="{ name: video_input.thumbnail.split('/').pop() }"
                  @delete="poster_deleted = true"
                />

                <a-button @click="$refs.videoPosterRef.click()">
                  <a-icon type="upload" />Выберите файл
                </a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-tab-pane>

        <span v-if="form.id" slot="tabBarExtraContent">
          <a-popconfirm
            placement="bottomRight"
            title="Вы действительно хотите удалить?"
            @confirm="removeForm"
          >
            <a-button :disabled="pending" style="margin-right: 10px">
              <a-icon type="delete" />Удалить
            </a-button>
          </a-popconfirm>
        </span>
      </a-tabs>

      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="submit"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
import InputFileItem from "@/components/utils/input-file-item"
import { required } from "vuelidate/lib/validators"

import { mapActions } from "vuex"

const newsDefaultFields = () => ({
  title: {
    uz: "",
    oz: "",
    ru: "",
    en: "",
    tj: "",
    kz: ""
  },
  slug: "",
  position: 1,
  status: true
})

export default {
  components: {
    "image-upload": () => import("@/components/utils/image-upload"),
    InputFileItem
  },

  data: () => ({
    // eslint-disable-next-line no-undef
    langTab: $langPrefix,
    loading: false,
    pending: false,

    tabPane: "content",
    form: { ...newsDefaultFields() },
    fileList: [],
    main_image: null,
    video_file: [],
    video_poster_file: null,
    video_input: {
      file_type: 3,
      file: "",
      exclusive: false,
      title: ""
    },
    emptyTitle: false,
    current_slug: "",
    errors: {
      slug: ""
    },

    poster_deleted: false
  }),

  computed: {
    isTitleNull() {
      return !!(
        !this.form.title.uz &&
        !this.form.title.oz &&
        !this.form.title.ru &&
        !this.form.title.en
      )
    },
    titlesCheck() {
      return !!(
        this.$v.form.title.oz.$error ||
        this.$v.form.title.uz.$error ||
        this.$v.form.title.ru.$error
      )
    },
    filesList() {
      return (this.form && this.form.files) || []
    },
    photoList() {
      return (
        (this.form &&
          this.form.files &&
          this.form.files.filter((item) => [0, 1].includes(item.file_type))) ||
        []
      )
    },
    videoList() {
      return (
        (this.form &&
          this.form.files &&
          this.form.files.filter(
            (item) => item.file_type == 3 || item.file_type == 4
          )) ||
        []
      )
    },
    tabName() {
      if (this.$route.name == "gallery-detail") {
        if (this.form && this.form.type !== "") {
          if (this.form.type == 0) {
            return ["photo"]
          }

          if (this.form.type == 1) {
            return ["video"]
          }
        }
        return []
      }

      if (this.$route.name == "gallery-create" && this.$route.params.type) {
        if (
          ["photo", "video"].includes(this.$route.params.type.toLowerCase())
        ) {
          return [this.$route.params.type.toLowerCase()]
        }
      }

      return ["photo", "video"]
    }
  },

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },

  mounted() {
    // this.video_input.file_type
    this.$on("update:slug", this.onSlugChange)
  },

  // beforeDestroy() {
  //   this.$set(this, "form", { ...newsDefaultFields() });
  // },

  validations: {
    form: {
      position: {
        required
      },
      slug: {
        required
      }
    }
  },

  methods: {
    ...mapActions("gallery", ["fileCreate", "fileUpdate", "fileDelete"]),

    check2Null(arg) {
      const r = Object.values(arg).every((item) => !item)

      // console.log("check2Null", r);

      return r
    },
    translitAction() {
      try {
        const from = this.langTab,
          to = this.langTab == "uz" ? "oz" : "uz",
          methodName = this.langTab == "uz" ? "toKirill" : "toLatin"

        if (this.form.title[from]) {
          this.form.title[to] = this[methodName](this.form.title[from])
        }

        if (this.form.content[from]) {
          this.form.content[to] = this[methodName](this.form.content[from])
        }
      } catch (error) {
        console.error("translitAction error", error)
      }
    },
    copySlug() {
      this.copyStringToClipboard(
        `/${(this.tabName && this.tabName[0]) || "gallery"}/${this.form.slug}`
      )
      this.$message.success("ЧПУ скопирован")
    },
    onSlugChange(e) {
      const text = (e.target.value || "")
        .replace(/( )/gi, "-")
        .toLowerCase()
        .replace(/[^a-zA-Z0-9\\-]/gi, "")

      this.slugCheck({
        payload: { table: "post", slug: text },
        postType: "news"
      })

      this.form.slug = text
    },
    async fetchData() {
      this.fileList = []
      this.video_file = null

      if (this.$route.params.id) {
        this.loading = true
        try {
          const data = await this.$store.dispatch(
            "gallery/detail",
            this.$route.params.id
          )

          if (data) {
            // console.log("fetchData", data);
            this.form = {
              ...data,
              title: {
                ...this.langKeys,
                ...data.title
              }
            }

            this.current_slug = this.form.slug

            if ((this.videoList || []) != 0) {
              const sortedList = this.filesList.sort((a, b) => b.id - a.id)

              // console.log('sortedList', sortedList);
              if (sortedList != 0) {
                this.video_input = {
                  id: sortedList[0].id,
                  file: sortedList[0].file,
                  file_type: +sortedList[0].file_type || -1,
                  position: +sortedList[0].position || 1,
                  thumbnail: sortedList[0].thumbnail || "",
                  exclusive: sortedList[0].exclusive || false,
                  title: sortedList[0].title || ""
                }
              }
            }
          }
        } catch (err) {
          console.error(err)
          this.loading = false
        }

        this.loading = false
      }
    },
    updateFilesPosition() {
      let promises = []
      let otherImages = new FormData()
      const mainImage = this.fileList.find(
        (item) => item.id && item.uzid === this.main_image
      )

      if (mainImage) {
        otherImages.append("is_main", true)
        otherImages.append("file_type", 0)
        otherImages.append("position", 0)
        otherImages.append("file", mainImage.file || mainImage.fileTarget)
        promises.push(
          this.$api.post("/news/file/update/" + mainImage.id, otherImages)
        )
      }

      // console.log(+!!mainImage);

      // debugger;

      Array.from(this.fileList)
        .filter((item) => item.id && item.uzid !== this.main_image)
        .map((item, index) => {
          otherImages = new FormData()

          otherImages.append("is_main", false)
          otherImages.append("position", index + +!!mainImage)
          otherImages.append("file_type", 0)
          otherImages.append("file", item.file || item.fileTarget)

          promises.push(
            this.$api.post("/news/file/update/" + item.id, otherImages)
          )
        })

      Promise.all(promises)
        .then(
          (res) => {
            console.log(res)
          },
          (err) => {
            console.log(err)
          }
        )
        .then((res) => {
          console.log(res)
          this.$message.success("Позиции успешно сохранены")
        })
    },
    tabPaneChangeHandler(arg) {
      // tinymce reload fix, !!! important
      this.tabPane = arg
    },

    async deletePoster() {
      if (!this.video_input.id) return

      await this.fileDelete(this.video_input.id)
      this.poster_deleted = true
    },

    async submit() {
      // console.log("submit!");

      if (this.check2Null(this.form.title)) {
        this.emptyTitle = true
        return
      }

      if (this.errors.slug && this.current_slug != this.form.slug) {
        this.$message.error("ЧПУ занят, введите другое")
        return
      }

      if (
        this.tabName.includes("video") &&
        [3, 4].includes(this.video_input.file_type) &&
        !(this.video_poster_file || this.video_input.thumbnail)
      ) {
        this.$message.error("Выберите постер для видео")
        return
      }

      this.pending = true
      try {
        const f = new FormData()

        if (this.tabName.includes("photo")) {
          this.fileList.map((item) => {
            f.append("file", item.fileTarget)
          })
        }

        for (let k in this.form) {
          if (
            // eslint-disable-next-line no-prototype-builtins
            this.form.hasOwnProperty(k) &&
            k != "title" &&
            k != "files" &&
            k != "type"
          ) {
            f.append(k, this.form[k])
          }
        }

        f.append("type", (this.tabName.includes("video") && 1) || 0)

        f.append("title", JSON.stringify(this.form.title))

        const req = {
          method: this.form.id ? "update" : "create"
        }

        const data = await this.$store.dispatch(
          `gallery/${req.method}ItemAction`,
          {
            id: this.form.id,
            data: f
          }
        )

        this.form.id = (data && data.id) || this.form.id

        // console.log('gallery action res', data);

        if (this.tabName.includes("video")) {
          if (this.video_input.file_type == 1) {
            this.video_file.forEach((item) => {
              f.append("file", item)
            })
          } else if ([3, 4].includes(this.video_input.file_type)) {
            // console.log('File type is video 3 or 4');
            if (this.poster_deleted) {
              await this.deletePoster(this.video_input.id)
            } else {
              if (this.video_input.id) {
                // console.log('updating');
                await this.fileUpdate({
                  ...this.video_input,
                  thumbnail: this.video_poster_file
                })
              } else if ((data && data.id) || this.form.id) {
                // console.log('append new one');
                await this.fileCreate({
                  file: this.video_input.file,
                  exclusive: this.video_input.exclusive,
                  file_type: this.video_input.file_type,
                  title: this.video_input.title,
                  position: 1,
                  thumbnail: this.video_poster_file,
                  gallery_id: this.form.id
                })
              } else {
                // console.log('No form or data id');
                f.append("file", this.video_input.file)
                f.append("thumbnail", this.video_poster_file)
              }
            }
          }
        } else if (this.tabName.includes("photo")) {
          await Promise.all(
            this.fileList.map((item, index) => {
              if (item.fileTarget) {
                return this.fileCreate({
                  file: item.fileTarget,
                  exclusive: false,
                  file_type: 0,
                  position: index + 1,
                  gallery_id: data.id || this.form.id
                })
              }
            })
          )
        }

        if (data.id || data != -1) {
          this.$message.success("Успешно сохранено")
          this.$router.push({
            name: "gallery",
            query: { tab: (this.tabName && this.tabName[0]) || "photo" }
          })
        }

        // console.log("submit", data);
      } catch (err) {
        console.log(err)
        this.pending = false
      }

      this.pending = false
    },
    handleVideoInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.video_file = Array.from(e.target.files) || []

        this.$refs.videoRef.value = null
      }
    },

    handleVideoPosterInput(e) {
      if (e.target.files && e.target.files[0]) {
        this.video_poster_file = e.target.files[0]

        this.$refs.videoPosterRef.value = null
      }
    },

    async removeVideo(arg) {
      if (this.form && this.form.files) {
        const f = this.form.files.findIndex((item) => item.id == arg.id)

        if (f != -1) {
          const res = await this.$store.dispatch("file/deletePost", arg.id)

          if (res) {
            this.form.files.splice(f, 1)
          }
        }
      }
    },

    async removeForm() {
      try {
        const r = await this.$store.dispatch(
          "gallery/removeItemAction",
          this.form.id
        )
        if (r) {
          this.$message.success("Успешно удалено")
          this.$router.go(-1)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style></style>
